import { gql } from "@apollo/client";

export const GET_ALL_FRECUENCIA_DISTRIBUIDOR = gql`
query GetAllFrecuenciaDistribuidor(
    $skip: Int
    $take: Int
    $where: FrecuenciaDistribuidorFilterInput  
    $order : [FrecuenciaDistribuidorSortInput!] 
) {
    allFrecuenciaDistribuidor(skip: $skip, take: $take, where: $where, order: $order )
    {
        items{
            idFrecuenciaDistribuidor,
            idProveedorDistribuidor,
            kilometroDestino,
            costoEntregaInmediata,
            idDeposito,
            activo,
            idProveedorDistribuidorNavigation {
              idProveedorDistribuidor,
              razonSocial
            },
            idDepositoNavigation {
              idDeposito,
              descripcion
            },
            idFrecuenciaModoDespachoNavigation {
              idFrecuenciaModoDespacho,
              descripcion
            },
            frecuenciaDistribuidorCP{
              idFrecuenciaDistribuidorCP,
              idCodigoPostal,
              idCodigoPostalNavigation {
                idCodigoPostal,
                cP,
                idProvincia,
                localidad,
                idProvinciaNavigation {
                  idProvincia,
                  descripcion
                }
              }
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;